// Convert project name to URL-friendly slug (no dashes)
export function slugify(text) {
  if (!text) return '';

  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '')         // Remove all spaces
    .replace(/[^\w]+/g, '');     // Remove all non-word chars
}

// Get slug for a project (uses name)
export function getProjectSlug(project) {
  return slugify(project?.name || '');
}
